


























import { defineComponent } from '@vue/composition-api'
import { mapMutations, mapState } from 'vuex'
import CreateDialog from './CreateDialog.vue'

export default defineComponent({
  components: { CreateDialog },
  computed: {
    ...mapState('alert', ['title', 'content', 'model', 'color']),
  },
  methods: {
    ...mapMutations('alert', ['toggle', 'resolve', 'reject']),
    onInput(payload: boolean) {
      this.reject()
      this.toggle(payload)
    },
  },
})
